module.exports = __webpack_public_path__ + "img/hsbc-video-thumbnail.60f974df.jpg";